module.exports = __webpack_public_path__ + "static/khan-thumbnail-b099bcdec4b3ad4a581b15e0acd7dd43.jpg";